import BarChart from '../../../../components/BarChart';
import Detail from '../../../../components/Detail';
import { formatAmountWithSuffix } from '../../../../helpers/formats';
import useTotalAccumulatedVoSpool from '../../../../hooks/web3/vault/useTotalAccumulatedVoSpool';
import useTotalStakedSpool from '../../../../hooks/web3/vault/useTotalStakedSpool';

const VoSpoolAccumulatedByCommunity = () => {
    const { totalStakedSpool } = useTotalStakedSpool();

    const { totalAccumulatedVoSpool } = useTotalAccumulatedVoSpool();

    return (
        <Detail
            title={`voSPOOL Accumulated by Community`}
            value={
                <>
                    <div>
                        {formatAmountWithSuffix(totalAccumulatedVoSpool || 0)}/
                        {formatAmountWithSuffix(totalStakedSpool || 0)} $SPOOL
                    </div>
                    <BarChart
                        value={totalAccumulatedVoSpool || 0}
                        total={totalStakedSpool || 0}
                    />
                </>
            }
        />
    );
};

export default VoSpoolAccumulatedByCommunity;
